import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function preguntasFrecuentesHomeReducer(state= initialState.preguntasFrecuentesHome, action){
	switch(action.type){
		case types.LOAD_PREGUNTAS_FRECUENTES_SUCCESS:		            
			return action.datos;		
	
		default:
			return state;
	}
}